import React from 'react';
import Drawer, { DrawerTarget, DrawerTrigger } from '@jetshop/ui/Modal/Drawer';
import { ElevateFacetsButton } from './ElevateFacetsButton';
import { cx } from 'linaria';
import { theme } from '../../Theme';
import { styled } from 'linaria/react';
import { ElevateFacets } from './ElevateFacets';
import { ElevateActiveFacets } from './ElevateActiveFacets';

const FlyoutTargetWrapper = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  background-color: white;

  /* Typography matching MobileMenuDrawer */
  font-family: ${theme.fonts.primary};
  color: ${theme.colors.primary};
`;

const FacetsButtonAndChipsContainer = styled('div')`
  max-width: 90rem;
  padding: 30px 12px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 1rem;
  align-items: center;
  flex-wrap: wrap;

  ${theme.below.md} {
    padding: 16px 12px;
  }
`;

export const ElevateFacetsFlyout = ({
  page,
  facets,
  sort,
  totalHits,
  originalTerm
}) => {
  let activeFacets = 0;

  facets?.forEach(facet => {
    const selectedCount = facet?.selectedCount;
    if (selectedCount) {
      activeFacets += selectedCount;
    }
  });

  return (
    <div id="filter-and-sort" className={cx('filter-and-sort-wrapper')}>
      <FacetsButtonAndChipsContainer>
        <DrawerTrigger id="filterAndSortDrawer">
          {({ showTarget }) => (
            <ElevateFacetsButton
              nrOfActiveFacets={activeFacets}
              openFacets={showTarget}
            />
          )}
        </DrawerTrigger>
        <ElevateActiveFacets facets={facets} />
      </FacetsButtonAndChipsContainer>

      <DrawerTarget id="filterAndSortDrawer">
        {({ hideTarget, isOpen }) => (
          <Drawer isOpen={isOpen} left size={390}>
            <FlyoutTargetWrapper>
              <ElevateFacets
                page={page}
                nrOfActiveFacets={activeFacets}
                totalHits={totalHits}
                sort={sort}
                facets={facets}
                hideTarget={hideTarget}
                originalTerm={originalTerm}
              />
            </FlyoutTargetWrapper>
          </Drawer>
        )}
      </DrawerTarget>
    </div>
  );
};
